import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import SignIn from '../components/signin/SignIn.jsx';

const mapStateToProps = (state) => {
  return {
    signInDialogOpen: state.signInDialogOpen,
  }
}

class SignInContainer extends Component {
  render () {
    const {
      signInDialogOpen,
      auth
    } = this.props;

    return (
      <ReactCSSTransitionGroup transitionName="fade" transitionEnterTimeout={700} transitionLeaveTimeout={700}>
        {signInDialogOpen
          ? <SignIn auth={auth} />
          : null
        }
      </ReactCSSTransitionGroup>
    )
  }
}

export default SignInContainer = connect(mapStateToProps, undefined)(SignInContainer);



// WEBPACK FOOTER //
// ./src/containers/SignInContainer.jsx